import { styled } from 'baseui'

export const TableWrap = styled('div', {
  position: 'relative',
  overflowX: 'auto',
  marginTop: '-0.45rem',
})

export const Table = styled('table', {
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
})

export const TheadRow = styled('tr', {
  textAlign: 'left',
})

export const Th = styled('th', {
  paddingTop: '0.35rem',
  paddingBottom: '0.35rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: '#E6EAF2',
  fontSize: '0.9125rem',
  color: '#6B7280',
  fontWeight: 600,
  whiteSpace: 'nowrap',
})

export const Td = styled('td', {
  paddingTop: '0.35rem',
  paddingBottom: '0.35rem',
  paddingLeft: '0.65rem',
  paddingRight: '0.65rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: '#F0F3F8',
  fontSize: '0.875rem',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
})

export const TdNarrowCenter = styled(Td, {
  width: '3.75rem',
  textAlign: 'center',
})

export const ContactIdCell = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.375rem',
})

export const CountryFlagWrap = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
})

export const ThSubLabel = styled('div', {
  fontSize: '0.75rem',
  color: '#6B7280',
  fontWeight: 300,
  textAlign: 'center',
})

export const IdTopLine = styled('div', {
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#111827',
  lineHeight: 1.1,
})

export const IdBottomLine = styled('div', {
  fontSize: '0.75rem',
  color: '#6B7280',
  lineHeight: 1.1,
  marginTop: '0.125rem',
})

export const ContactTd = styled(Td, {
  minWidth: '17rem',
})

export const ContractTypeTd = styled(Td, {
  width: '7.5rem',
})

export const ContactCell = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  lineHeight: 1.15,
})

export const ContactNameText = styled('span', {
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#111827',
})

export const ContactEmailText = styled('span', {
  fontSize: '0.75rem',
  color: '#6B7280',
  overflowWrap: 'anywhere',
})

export const DateTimeCell = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const DateText = styled('span', {
  fontSize: '0.875rem',
})

export const TimeText = styled('span', {
  fontSize: '0.75rem',
  color: '#6B7280',
})

export const ContractTypeCellVertical = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
})

export const ContractTypeSmallLabel = styled('span', {
  fontSize: '0.75rem',
})

export const ActionsCell = styled('td', {
  minWidth: '15rem',
  width: '15rem',
  verticalAlign: 'middle',
})

export const ActionsRow = styled('div', {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'nowrap',
})

export const FooterRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  marginTop: '0.75rem',
})

export const FooterActions = styled('div', {
  gridColumn: 2,
  display: 'flex',
  gap: '0.5rem',
  justifyContent: 'center',
})

export const MutedText = styled('span', {
  fontSize: '0.75rem',
  color: '#6B7280',
})

export const NoContractPill = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  paddingTop: '0.25rem',
  paddingBottom: '0.25rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  borderRadius: '0.625rem',
  backgroundColor: '#F3F4F6',
  color: '#6B7280',
  fontSize: '0.75rem',
  fontWeight: 600,
})

export const ActionButtonOverrides = {
  BaseButton: {
    style: {
      fontSize: '0.75rem',
      paddingTop: '0.375rem',
      paddingBottom: '0.375rem',
      paddingLeft: '0.4rem',
      paddingRight: '0.4rem',
    },
  },
}

export const TableLoadingOverlayWrap = styled('div', {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: 'rgba(255,255,255,0.8)',
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const TableLoadingContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.75rem',
  fontSize: '0.875rem',
  color: '#374151',
})
